import { useUserExternalAccountsQuery } from '@/modules/user-external-accounts/queries/useUserExternalAccountsQuery';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

/** Whether the customer's LinkedIn is usable, or why that is not known yet. */
export type LinkedInStatus = 'pending' | 'error' | 'connected' | 'disconnected';

export const useIsLinkedInConnected = () => {
  const currentUserQuery = useCurrentUserQuery();
  const userExternalAccountsQuery = useUserExternalAccountsQuery(
    currentUserQuery.data?.id,
  );

  const linkedInAccountId = userExternalAccountsQuery.data?.find(
    (account) => account.type === 'LinkedIn' && account.status === 'Active',
  )?.id;
  const isLinkedInConnected = linkedInAccountId !== undefined;

  const linkedInStatus: LinkedInStatus =
    currentUserQuery.isError || userExternalAccountsQuery.isError
      ? 'error'
      : currentUserQuery.isPending || userExternalAccountsQuery.isPending
        ? 'pending'
        : isLinkedInConnected
          ? 'connected'
          : 'disconnected';

  const retryLinkedInLookup = () => {
    if (currentUserQuery.isError) void currentUserQuery.refetch();
    else void userExternalAccountsQuery.refetch();
  };

  return {
    userId: currentUserQuery.data?.id,
    linkedInAccountId,
    isLinkedInConnected,
    linkedInStatus,
    retryLinkedInLookup,
  };
};
